<template>
  <div class="content-box" v-if="isPasswordChecked">
    <!-- 마이페이지 사용자정보 -->
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />
      <div class="sub-contents">
        <div class="border-title title">
          <h4 class="title">연락처 관리<span class="desc">자주 사용하는 휴대전화 번호를 등록해 두면 주문 시 더 편리하게 이용할 수 있습니다.</span></h4>
        </div>
        <!-- 연락처 총건수 & 연락처 등록 버튼 영역 -->
        <div class="box-gray inset40 mt28">
          <div class="big-text-wrap">
            <p class="big-text">현재 등록된 연락처는 총 <strong class="text-green">{{totalRcvrTelno}}건</strong>입니다.</p>
            <button type="button" class="btn btn-outline" @click="rcvTelnoRegistrate">연락처 등록</button>
          </div>
        </div>
        <!-- 연락처 조회 조건 영역 -->
        <div class="box-gray mt40 search">
          <fieldset class="search-form-wrap">
            <legend>등록한 연락처 검색 폼</legend>
            <div class="search-form">
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="selectBox" :key="selectBoxKey" v-model:model-value="selectedRcvrGrpNm" label="연락처 그룹" :hide-label="false" defaultLabel="전체" selectBoxTitleClass="w300" :options="rcvrGrpNmList"/>
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="selectBox" label="검색어" v-model:model-value="selectedSearchOption" :hide-label="false" defaultLabel="이름" selectBoxTitleClass="w300" :options="['이름', '휴대전화번호']"/>
                  <HconInput v-if="selectedSearchOption === '이름'" v-model:model-value="inputSearchValue" type="text" inputClass="ml8" placeholder="이름으로 검색해주세요." @button-click="handleReceiveTelnoInfo"/>
                  <HconInput v-if="selectedSearchOption === '휴대전화번호'" v-model:model-value="inputSearchValue" type="text" pattern="num" :maxlength="11" inputClass="ml8" placeholder="휴대전화번호로 검색해주세요." @button-click="handleReceiveTelnoInfo"/>
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button type="button" class="btn lg" @click="handleReceiveTelnoInfo">조회</button>
            </div>
          </fieldset>
        </div>
        <!-- 전체 체크박스 영역 -->
        <div class="contents-title-wrap mt40 mb15">
          <div class="contents-title">
            <HconCheckBox type="checkTitle" :checked="checkedAll" @change="changeCheckedAll" label="선택" :num="checkedAllCount" :unit="'명'" name="allCheckBtn" labelClass="top-check-title" :hide-label="false"/>
          </div>
          <div class="rgt-area">
            <span class="total text-gray">총 <em class="count">{{totalRcvrTelno}}</em>명</span>
            <span class="text-gray02">(최대 <span class="count">10,000</span>명)</span>
          </div>
        </div>
        <!-- 연락처 목록 header 영역 -->
        <div :class="vScroll.hasScroll.value && rcvrInfo.length > 0 && isTableLoading === false ? 'pr10' : ''">
          <table class="tbl-type2">
            <caption>검색된 연락처 목록</caption>
            <colgroup>
              <col style="width:5.5%;"/>
              <col style="width:5%;">
              <col style="width:25%;">
              <col style="width:13%;">
              <col style="width:auto;">
              <col style="width:12%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="xs"></th>
                <th scope="col" class="xs">No</th>
                <th scope="col" class="xs">연락처 그룹</th>
                <th scope="col" class="xs">이름</th>
                <th scope="col" class="xs">휴대전화번호</th>
                <th scope="col" class="xs">삭제</th>
              </tr>
            </thead>
          </table>
        </div>
        <!-- 연락처 목록 body 영역 -->
        <div class="contents-detail-wrap">
          <div class="relative hg441 y-auto" ref="container" @scroll="onScroll">
            <table class="tbl-type2" :class="rcvrInfo.length > 0 && isTableLoading === false ? '' : 'h100p'" :style="{transform: `translateY(${vScroll.offset.value}px)`, position: 'absolute', top: '0', left: '0', width: '100%', tableLayout: 'fixed'}">
              <caption>검색된 연락처 목록</caption>
              <colgroup>
                <col style="width:5.5%;"/>
                <col style="width:5%;">
                <col style="width:25%;">
                <col style="width:13%;">
                <col style="width:auto;">
                <col style="width:12%;">
              </colgroup>
              <!-- 데이터 로딩 시에 로딩바 -->
              <tbody v-if="isTableLoading" class="h100p" style="position: static">
                <tr>
                  <td colspan="6" class="loading"><HconLoading v-model="isLoadingShow"/></td>
                </tr>
              </tbody>
              <!-- 데이터 있음 -->
              <tbody v-if="rcvrInfo && rcvrInfo.length > 0">
                <tr :style="{transform: `translateY(${vScroll.offset.value}px)`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0;" class="hg0"></td>
                </tr>
                <tr v-for="(item, index) in vScroll.visibleItems.value" :key="`${item.rcvrMblTelno}-${item.rcvrMblTelnoSeq}`" :style="{ height: `${ITEM_HEIGHT}px`}">
                  <td class="small">
                    <HconCheckBox type="default" :disabled="checkedDisabled" :checked="item.isChecked" @change="changeChecked(item.rcvrMblTelno, item.rcvrMblTelnoSeq, $event)" :spanShowLabel="true" :spanA11yLabel="true" :label="`${item.rcvrGrpNm} ${item.rcvrNm} ${item.rcvrMblTelno}`" name="checkTable" :hide-label="true" :custom-class="'jc-r'"/>
                  </td>
                  <td class="small">{{vScroll.startIndex.value + currentNo + index}}</td>
                  <td class="small"><div class="ellips">{{item.rcvrGrpNm}}</div></td>
                  <td class="small">{{item.rcvrNm}}</td>
                  <td class="small">{{HconCommonUtils.format.phone(item.rcvrMblTelno)}}</td>
                  <td class="small btn-hover"><button type="button" @click="handleDelete(item.rcvrMblTelno, item.rcvrMblTelnoSeq)" class="btn btn-outline-gray xs">삭제</button></td>
                </tr>
                <tr :style="{ height: `${Math.max(0, vScroll.totalHeight.value - vScroll.offset.value - (vScroll.visibleItems.value.length * ITEM_HEIGHT))}px`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0;" class="hg0"></td>
                </tr>
              </tbody>
              <!-- 데이터 없음 -->
              <tbody v-else :class="rcvrInfo.length > 0 ? '' : 'h100p'">
                <tr>
                  <td colspan="6" class="nodata">연락처 내역이 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div> 
          <!-- 버튼 영역 -->
          <div class="button-box jc-l mt20">
            <button type="button" class="btn btn-outline" @click="handleCheckedDelete">선택 삭제</button>
          </div>
        </div>
      </div>
    </div> 
  </div>
  <!-- 비밀번호 확인 팝업 -->
  <HconComPasswordCheckPopup v-if="!isPasswordChecked" @success="handleCheckSuccess"/>
  <!-- 연락처 등록 팝업 -->
  <HconReceiveTelnoPopupRegistration v-if="receiveTelnoPopupOpen" @success="handlePopup" @cancel="handlePopup"/>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconDropDown from '@/components/com/HconComPCDropDown.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconLoading from '@/components/com/HconComPCLoading.vue';
import HconComPasswordCheckPopup from '~/components/com/HconComPasswordCheckPopup.vue';
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import HconReceiveTelnoPopupRegistration from '~/components/popup/HconReceiveTelnoPopupRegistration.vue';
import { usePopup } from '@/composables/hconUsePopup'
import { COMMON_CODE, MEMBER_CODE, ORDER_CODE } from '~/constants/hconMessageConstants';
import type { RcvrGrpNmDto, ReceiveTelnoInfoDto, ReceiveTelnoInfoListDto } from '~/types/mypage/backend-dto-types';

// 팝업
const {showConfirm, showAlert} = usePopup()

// 패스워드 확인 팝업 검증 여부
const isPasswordChecked = ref(false)

// 패스워드 확인 팝업 검증 성공 후 이벤트
const handleCheckSuccess = async () => {
  
  isPasswordChecked.value = true
  
  await nextTick()

  // 초기 연락처 목록 조회
  receiveTelnoInfo(false) 

  // containerHeight 값 세팅
  if (container.value) {
    vScroll.setContainerHeight(container.value)
  }
  
}

// 연락처 그룹 선택 값
const selectedRcvrGrpNm = ref<string | null>('전체')
// 연락처 그룹 API 보낼 값
const rcvrGrpNmParam = ref<string | null>(null)
// 검색어 옵션
const selectedSearchOption = ref('이름')
// 검색어 값
const inputSearchValue = ref('')
// 등록된 연락처 총건수 
const totalRcvrTelno = ref(0)
// 필터 적용 연락처 총건수
const filterTotalRcvrTelno = ref(0)
// 연락처 No
const currentNo = ref<number>(1)
// (삭제 연락처)
const deleteRcvrMblTelno = ref('')
// (삭제 순번)
const deleteRcvrMblTelnoSeq = ref(0)
// 개별 체크박스 disabled 변수
const checkedDisabled = ref(false);
// 연락처그룹 selectBox key 값
const selectBoxKey = ref(0)
// 행 전체 선택 시 상태 변수 저장
const lastRcvrTelnoState = ref<{selectedRcvrGrpNm:string | null; inputSearchValue:string;}>
({selectedRcvrGrpNm: '전체', inputSearchValue:''})
// 연락처 등록 팝업 
const receiveTelnoPopupOpen = ref(false);

// 연락처 목록 조회 API 결과 값
const rcvrInfo = ref<ReceiveTelnoInfoDto[]>([]);
// 수신자그룹명 목록 조회 API 결과 값
const rcvrGrpNmInfo = ref<RcvrGrpNmDto[]>();
// 수신자그룹명 목록 list 변환 
const rcvrGrpNmList = ref<string[]>();

// 선택한 행들 목록
const checkedList = computed(() => {
  return rcvrInfo.value.filter(item => item.isChecked === true).map((item: any) => ({
    rcvrMblTelno: item.rcvrMblTelno,
    rcvrMblTelnoSeq: item.rcvrMblTelnoSeq
  }))
})

// 행 전체 선택 
const checkedAll = computed(() => {
  return rcvrInfo.value && rcvrInfo.value.length > 0 && rcvrInfo.value.every(item => item.isChecked)
})

// 행 전제 선택 갯수
const checkedAllCount = computed(() => {

  const {selectedRcvrGrpNm: lastSelectedRcvrGrpNm, inputSearchValue: lastInputSearchValue} = lastRcvrTelnoState.value

  // 조건 필터 적용 없이 전체선택인 경우
  if(lastSelectedRcvrGrpNm === '전체' && lastInputSearchValue === '' && checkedAll.value === true) {
    return totalRcvrTelno.value
  }
  // 조건 필터 적용이면서 전체선택인 경우
  if(checkedAll.value === true) {
    return filterTotalRcvrTelno.value
  }

  // 개별선택인 경우
  return rcvrInfo.value.filter(item => item.isChecked).length

})

// 행 전체 선택 change 이벤트 
const changeCheckedAll = (isCheckedStatus:boolean) => {
  if(rcvrInfo.value) {
    rcvrInfo.value.forEach(item => {
    item.isChecked = isCheckedStatus
  })
  // 전체 선택 시 개별 선택 비활성화 처리
  checkedDisabled.value = isCheckedStatus;
  }
}

// 행 개별 선택 change 이벤트 
const changeChecked = (isCheckedTelno:String, isCheckedSeq:Number, isCheckedStatus:boolean) => {
  const checkedSeq = rcvrInfo.value.find(item => item.rcvrMblTelno === isCheckedTelno && item.rcvrMblTelnoSeq === isCheckedSeq)
  if(checkedSeq) {
    checkedSeq.isChecked = isCheckedStatus
  } 
}

// 가상 스크롤 변수 선언
const ITEM_HEIGHT = 40
const isLoading = ref(false)
const page = ref(1)
const isLastPage = ref(false)
const vScroll = useVirtualScroll(rcvrInfo, ITEM_HEIGHT)

const container = ref<HTMLElement | null>(null)

// scroll 이벤트
const onScroll = (event: Event) => {
  vScroll.handleScroll(event, () => {
    if (!isLoading.value && !isLastPage.value) {
      receiveTelnoInfo(false)
    }
  })
}

// 로딩 상태값
const isTableLoading = ref(true)
const isLoadingShow = ref(true)

// 조회 버튼 click or Enter 키 
const handleReceiveTelnoInfo = () => {
  // 연락처 목록 조회(상태값 초기화)
  receiveTelnoInfo(true)
}

const fetchBuilder  = useHconFetchBuilder();

// 연락처 목록 조회 API 호출
const receiveTelnoInfo = async (isReset:boolean, deleteAllYn?:boolean) => {
  // API 중복 호출 방지
  if(isLoading.value || (isLastPage.value && !isReset)) return
  // 로딩 시작
  isLoading.value = true
  isTableLoading.value = true
  isLoadingShow.value = true
  // 연락처 그룹 or 검색어로 조회 시 상태 초기화
  if(isReset) {
    // 연락처 전체선택 삭제의 경우 삭제 후 연락처 그룹 초기화 
    if(deleteAllYn) {
      selectedRcvrGrpNm.value = '전체'
      selectBoxKey.value++
      inputSearchValue.value = ''
    }
    rcvrGrpNmParam.value = selectedRcvrGrpNm.value === '전체' ? null : selectedRcvrGrpNm.value
    page.value = 1
    isLastPage.value = false
    rcvrInfo.value = []
    checkedDisabled.value = false
    lastRcvrTelnoState.value = {
      selectedRcvrGrpNm: selectedRcvrGrpNm.value,
      inputSearchValue: inputSearchValue.value,
    }
    // 스크롤 값 초기화
    vScroll.setScrollTop(0)
    
    if(container.value) {
      vScroll.setContainerHeight(container.value)
      container.value.scrollTop = 0
    }
  }

  // API 호출
  const fetchBuilderResult = 
  await fetchBuilder.post<AjaxResult<ReceiveTelnoInfoListDto>>('/api/v1/mypage/receivePerson/receiveTelnoInfo')
  .body({
    rcvrGrpNm: rcvrGrpNmParam.value,
    rcvrNm: selectedSearchOption.value === '이름'? inputSearchValue.value.trim() : '',
    rcvrMblTelno: selectedSearchOption.value === '휴대전화번호'? inputSearchValue.value.trim().replace(/-/g,''): '',
    pageNum: page.value
  })
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      // 연락처 목록 데이터가 있을 때
      if(Object.values(result.data?.['receiveTelnoInfoDto']).length >= 0) {
        // 데이터 누적(20건씩)
        rcvrInfo.value.push(
          ...result.data['receiveTelnoInfoDto'].map((item: any) => ({...item, isChecked : checkedAll.value}))
        )
        // 총 건수는 DB에 등록된 총건수를 말함 => 조건 값에 따라 변경되면 안됨
        if(rcvrGrpNmParam.value === null && inputSearchValue.value === '' && rcvrInfo.value.length >= 0) {
          // 총건수 세팅
          totalRcvrTelno.value = rcvrInfo.value.length > 0 ? rcvrInfo.value[0].totalCount : 0
        }
        // 필터 적용 총건수 세팅
        filterTotalRcvrTelno.value = rcvrInfo.value[0].filterTotalCount
        // 조회된 데이터가 20건 미만일때 마지막 페이지 세팅
        if(rcvrInfo.value.length >= totalRcvrTelno.value) {
          isLastPage.value = true
        }
        // 페이지 증가
        page.value++ 
      }
      else {
        // 조회된 데이터가 없을때 마지막 페이지 세팅
        isLastPage.value = true
      }

      // 연락처 그룹 목록
      if(page.value === 2) {
        // 처음에 연락처 그룹 목록 조회 후 재조회 X
        rcvrGrpNmInfo.value = (result.data?.['rcvrGrpNmDto'] || []).map((item: any) => ({...item}))
        rcvrGrpNmList.value = rcvrGrpNmInfo.value?.map(item => item.rcvrGrpNm)
        rcvrGrpNmList.value?.unshift('전체')
      }
      
    }
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
  .finally(() => {
    // 로딩 완료
    isLoading.value = false
    isTableLoading.value = false
    isLoadingShow.value = false
  })

}

// 연락처 삭제 API 호출
const deleteReceiveTelno = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.put<AjaxResult<boolean>>('/api/v1/mypage/receivePerson/receiveTelno-delete')
  .body({
    rcvrMblTelno : deleteRcvrMblTelno.value,
    rcvrMblTelnoSeq: deleteRcvrMblTelnoSeq.value,
  })
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      if(result.data === true) {
        showAlert({
          title: '알림', 
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "삭제가"), /*{삭제가} 완료되었습니다.*/
          confirmText: '확인',
          onConfirm: () => {
            receiveTelnoInfo(true)
          }
        })
      }
    }  
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 연락처 선택 삭제 API 호출
const deleteReceiveTelnoList = async () => {
  const fetchBuilderResult = 
  await fetchBuilder.put<AjaxResult<boolean>>('/api/v1/mypage/receivePerson/receiveTelno-list-delete')
  .body({
    checkedList: checkedList.value,
    deleteAllYn: checkedAll.value === true ? 'Y' : 'N',
    rcvrGrpNm: rcvrGrpNmParam.value,
    rcvrNm: selectedSearchOption.value === '이름' ? inputSearchValue.value.trim() : '',
    rcvrMblTelno: selectedSearchOption.value === '휴대전화번호' ? inputSearchValue.value.trim().replace(/-/g,''): ''
  })
  .progressMessage("잠시만 기다려주세요...")
  .preventErrorNotify()
  .build()
  .execute()
  .then((result) => {
    if(result.resultCode == '200') {
      if(result.data === true) {
        showAlert({
          title: '알림', 
          message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9004, "삭제가"), /*{삭제가} 완료되었습니다.*/
          confirmText: '확인',
          onConfirm: () => {
            receiveTelnoInfo(true, true)
          }
        })
      }
    }  
  })
  .catch((error) => {
    // 응답코드가 200이 아닌경우
    if(error.resultCode != '200') {
      showAlert(error.resultMessage)
    }
  })
}

// 연락처 등록 버튼 click 이벤트
const rcvTelnoRegistrate = async () => {
  // 등록 가능한 연락처 건수 체크
  if(totalRcvrTelno.value === 10000) {
    showAlert({
      title: '알림',
      message : HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9163,"연락처는 최대 10,000건까지 등록이") /*{연락처는 최대 10,000건까지 등록이} 가능합니다.*/
    })
    receiveTelnoPopupOpen.value = false;
  }
  else {
    receiveTelnoPopupOpen.value = true;
  }
}

// 연락처 등록 팝업
const handlePopup = (value:any) => {
  receiveTelnoPopupOpen.value = false;
  // 정상적으로 연락처 등록 시 연락처 목록 재조회
  if(value === 'Y') {
    receiveTelnoInfo(true);
  }
}

// 삭제 버튼 클릭 시
const handleDelete = async (rcvrTelno:string, seq: number) => {
  
  deleteRcvrMblTelno.value = rcvrTelno
  deleteRcvrMblTelnoSeq.value = seq

  showConfirm({
    title: '연락처 삭제',
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9098), /*선택하신 연락처를 삭제하시겠습니까?<br/>삭제 후에는 복구할 수 없습니다.*/
    onConfirm: () => {deleteReceiveTelno()},
    cancelText: '취소'
  })
}

// 선택 삭제 버튼 클릭 시
const handleCheckedDelete = async () => {
  if(checkedList.value.length === 0) {
    showAlert({
      title: '알림', 
      message : HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9085), /*선택된 수신자 번호가 없습니다.<br/>수신자 번호를 선택해 주세요.*/
      confirmText: '확인',
    })
  } else {
    showConfirm({
      title: '연락처 삭제',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9098), /*선택하신 연락처를 삭제하시겠습니까?<br/>삭제 후에는 복구할 수 없습니다.*/
      onConfirm: () => {deleteReceiveTelnoList()},
      cancelText: '취소'
    })
  }
}

// 검색어 변경
watch(selectedSearchOption, (newVal1, oldVal1) => {
	// 검색어 드롭다운 변경 시 기존 input 값 초기화
  if(newVal1 !== oldVal1) {
    inputSearchValue.value = ''
  }
})

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>